<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>                                                                        
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <!--<div class="row">
    <div textInput [control]="datiGeneraliForm.controls['nruolo']"
        class="col-sm6" [labelInput]="'N&deg; ruolo'"
        formControlName="nruolo"
        [(ngModel)]="request.fascicolo.numeroRuolo"></div>

    <div naturalNumberInput [control]="datiGeneraliForm.controls['annoRuolo']"
        class="col-sm-6" [labelInput]="'Anno ruolo'" [maxLength]="'4'"
        formControlName="annoRuolo" [checkFormat]="true"
        [(ngModel)]="request.fascicolo.annoRuolo"></div>
  </div>

  <div class="row">
    <div textInput [control]="datiGeneraliForm.controls['sezione']"
        class="col-sm-6" [labelInput]="'Sezione'" formControlName="sezione"
        [(ngModel)]="request.fascicolo.sezione"></div>

    <div textInput [control]="datiGeneraliForm.controls['giudice']"
        class="col-sm-6" [labelInput]="'Giudice'" formControlName="giudice"
        [(ngModel)]="request.fascicolo.giudice"></div>
  </div>-->

  <div class="row container_fieldset">
    <div class="col-sm-12">
      <fieldset class="form-group">
        <legend>Decreto ingiuntivo</legend>
        <div textInput [control]="datiGeneraliForm.controls['numDecretoIngiuntivoRiferimento']"
        class="col-sm-4" [labelInput]="'N&deg; ruolo/decreto'"
          formControlName="numDecretoIngiuntivoRiferimento"
            [(ngModel)]="request.fascicolo.numDecretoIngiuntivoRiferimento"></div>
  
        <div textInputCurrency [control]="datiGeneraliForm.controls['valoreDecretoIngiuntivoRiferimento']"
            class="col-sm-4" [labelInput]="'Valore'" [location]="'SezioneEconomica'"
            formControlName="valoreDecretoIngiuntivoRiferimento"
            [(ngModel)]="request.fascicolo.valoreDecretoIngiuntivoRiferimento"></div>
  
        <div checkBoxRadio class="col-sm-4"
            [labelInput]="'Titolo esecutivo contestuale'" idInput="titolo_esecutivo_contestuale"
            formControlName="titoloContestualeAlPrecetto" [objectReference]="request.fascicolo.titoloContestualeAlPrecetto"
            (onReturn)="request.fascicolo.titoloContestualeAlPrecetto = $event"></div>
  
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
        [labelInput]="'Note'" formControlName="note"
        [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div
    *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi"
    class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)"></p>
    </div>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
      [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'"
      [disabled]="checkDisabled() || !datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
